import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = () => {
  const [openFAQ, setOpenFAQ] = useState(null);

  const faqs = [
    {
      question: 'What are the basic rights of employees in Kenya?',
      answer: 'Employees in Kenya have fundamental rights including fair wages, safe working conditions, non-discrimination, right to form unions, and protection against unfair dismissal. The Constitution and Employment Act provide comprehensive protection for worker rights.'
    },
    {
      question: 'How much notice is required for termination of employment?',
      answer: 'The notice period depends on the length of service and terms of employment. Generally, it ranges from 7 days for employees with less than 6 months service to 28 days for those with over 2 years service. Senior positions may require longer notice periods as per contract terms.'
    },
    {
      question: 'What constitutes unfair dismissal in Kenya?',
      answer: 'Unfair dismissal occurs when an employee is terminated without valid reason, without proper procedure, or in violation of employment laws. This includes dismissal based on discrimination, union membership, or failure to follow due process.'
    },
    {
      question: 'How are employment disputes resolved in Kenya?',
      answer: 'Employment disputes are typically resolved through internal grievance procedures, mediation, arbitration, or through the Employment and Labour Relations Court. We recommend attempting resolution through dialogue before proceeding to formal legal action.'
    },
    {
      question: 'What are the requirements for employment contracts?',
      answer: 'Employment contracts must be in writing for contracts exceeding one month, clearly stating terms of employment, job description, remuneration, working hours, leave entitlements, and termination procedures. Both parties must understand and agree to all terms.'
    },
    {
      question: 'How do I file a complaint for workplace discrimination?',
      answer: 'Workplace discrimination complaints can be filed with the Employment and Labour Relations Court or relevant regulatory bodies. Document all incidents, report to HR if applicable, and seek legal counsel to understand your rights and options for redress.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <section className="py-16 bg-gradient-to-br from-surface/10 to-primary/5">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-heading font-bold text-text-primary mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-text-secondary">
            Common questions about employment and labor law in Kenya
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl border border-border-light overflow-hidden shadow-sm"
            >
              <button
                className="w-full px-8 py-6 text-left flex items-center justify-between hover:bg-surface/20 transition-colors duration-200"
                onClick={() => toggleFAQ(index)}
              >
                <h3 className="text-lg font-heading font-semibold text-text-primary pr-4">
                  {faq.question}
                </h3>
                <Icon
                  name={openFAQ === index ? 'ChevronUp' : 'ChevronDown'}
                  size={20}
                  className="text-text-secondary flex-shrink-0"
                />
              </button>
              {openFAQ === index && (
                <div className="px-8 pb-6">
                  <p className="text-text-secondary leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-text-secondary mb-4">
            Have more questions about employment law?
          </p>
          <button
            onClick={() => {
              const message = encodeURIComponent("Hello, I have questions about employment law services.");
              window.open(`https://wa.me/254721320787?text=${message}`, '_blank');
            }}
            className="inline-flex items-center space-x-2 bg-primary text-white px-6 py-3 rounded-lg hover:bg-primary/90 transition-colors duration-200"
          >
            <Icon name="MessageCircle" size={20} />
            <span>Ask Our Experts</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;